export const TOOLTIP_WIDTH_EXPANDED = 36;
